import React, { memo, useCallback, useState } from 'react';
import clsx from 'clsx';

import CommonPopper from '../common-popper/CommonPopper';
import CommonMenu from './CommonMenu';
import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';

const CommonMenuSubmenu = ({ submenuOptions, onSelect, label }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuOpened = useCallback(() => {
    setIsMenuOpen(true);
  }, []);

  const handleMenuClosed = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  const handleSelect = useCallback(
    (selectedValue) => {
      onSelect(selectedValue);
    },
    [onSelect],
  );

  const Menu = () => {
    return <CommonMenu options={submenuOptions} onSelect={handleSelect} />;
  };

  return (
    <CommonPopper
      component={Menu}
      options={submenuPopperOptions}
      placement='left-start'
      isShowCaret={false}
      onOpen={handleMenuOpened}
      onClose={handleMenuClosed}>
      <li
        className={clsx(
          'common-menu_item',
          'common-menu_submenu_item',
          isMenuOpen && 'common-menu_submenu_item--selected',
        )}>
        <Icon
          icon={ICONS.CaretUp}
          disableCommonStyles
          currentColor
          className={clsx('common-menu_submenu_item_icon', 'common-menu_submenu_item_icon--left')}
        />
        {label}
      </li>
    </CommonPopper>
  );
};

export default memo(CommonMenuSubmenu);

export const submenuPopperOptions = [
  {
    name: 'flip',
    enabled: true,
    options: {
      altBoundary: true,
      rootBoundary: 'document',
    },
  },
  {
    name: 'preventOverflow',
    enabled: true,
    options: {
      altAxis: true,
      altBoundary: true,
      tether: true,
      boundary: 'document',
      padding: 20,
    },
  },
  {
    name: 'offset',
    options: {
      offset: [0, 10],
    },
  },
];
